import { SidebarList } from "components/SidebarList";
import React from "react";
import { FaBars, FaSearch, FaArrowsAltV } from "react-icons/fa";
import {
  isAccountantUser,
  isAdmin,
  isCommercialUser,
  isLabEmployee,
  isLabExpert,
  isLabHead,
  isLabHeadDeputy,
  isTenderUser,
} from "utils/defineUser";

const MAIN_LIST = [
  {
    link: "/sout/locations/potential",
    content: "Потенциальные",
    type: "default",
  },
  {
    link: "",
    content: "",
    type: "space",
  },
  {
    link: "/sout/locations/Compare",
    content: (
      <>
        <FaArrowsAltV className="sidebar__icon-search" />{" "}
        <b className="sidebar__search-span">Сравнение</b>
      </>
    ),
    type: "default",
  },
  {
    link: "",
    content: "",
    type: "space",
  },
  {
    link: "/sout/locations/GlobalSearch",
    content: (
      <>
        <FaSearch className="sidebar__icon-search" />{" "}
        <b className="sidebar__search-span">Общий поиск</b>
      </>
    ),
    type: "default",
  },
  {
    link: "/sout/locations/Actual",
    content: (
      <>
        <FaBars className="sidebar__icon-search" />{" "}
        <b className="sidebar__search-span">Все актуальные </b>
      </>
    ),
    type: "default",
  },
  {
    link: "/sout/locations/unassigned",
    content: "Неназначенные",
    type: "default",
  },
  {
    link: "/sout/locations/planned",
    content: "Планируемые",
    type: "default",
  },
  {
    link: "/sout/locations/inLeaving",
    content: "На выезде",
    type: "default",
  },
  {
    link: "/sout/locations/finish",
    content: "Завершённые",
    type: "default",
  },
  {
    link: "/sout/locations/archive",
    content: "Архив",
    type: "archive",
  },
  {
    link: "/sout/locations/suspended",
    content: "Приостановленные",
    type: "no-result-space",
  },
  {
    link: "/sout/locations/basket",
    content: "Корзина",
    type: "no-result",
  },
  {
    link: "/sout/locations/potentialBasket",
    content: "Корзина потенциальных ЗБ",
    type: "no-result",
  },
];

const LocationsSidebar = ({ toggleSidebar, isOpen }) => {
  return (
    <>
      {isCommercialUser() || isAdmin() ? (
        <SidebarList
          title="Коммерческий отдел"
          titleIsOpen={isOpen.commercial}
          toggleSidebar={() => toggleSidebar("commercial")}
          color="olive"
          items={[
            {
              type: "line",
            },
          ]}
        />
      ) : null}
      {isTenderUser() || isAdmin() ? (
        <SidebarList
          title="Тендерный отдел"
          titleIsOpen={isOpen.tender}
          toggleSidebar={() => toggleSidebar("tender")}
          color="olive"
          items={MAIN_LIST}
        />
      ) : null}
      {isLabHead() || isAdmin() ? (
        <SidebarList
          title="Начальник лаборатории"
          titleIsOpen={isOpen.lab_chief}
          toggleSidebar={() => toggleSidebar("lab_chief")}
          color="olive"
          items={[
            {
              link: "/sout/locations/Compare",
              content: (
                <>
                  <FaArrowsAltV className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Сравнение</b>
                </>
              ),
              type: "default",
            },
            {
              link: "",
              content: "",
              type: "space",
            },
            {
              link: "/sout/locations/GlobalSearch",
              content: (
                <>
                  <FaSearch className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Общий поиск</b>
                </>
              ),
              type: "default",
            },
            {
              link: "/sout/locations/Actual",
              content: (
                <>
                  <FaBars className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Все актуальные </b>
                </>
              ),
              type: "default",
            },
            {
              link: "/sout/locations/unassigned",
              content: "Неназначенные",
              type: "default",
            },
            {
              link: "/sout/locations/planned",
              content: "Планируемые",
              type: "default",
            },
            {
              link: "/sout/locations/inLeaving",
              content: "На выезде",
              type: "default",
            },
            {
              link: "/sout/locations/finish",
              content: "Завершённые",
              type: "default",
            },
            {
              link: "/sout/locations/archive",
              content: "Архив",
              type: "archive",
            },
            {
              link: "/sout/locations/basket",
              content: "Корзина",
              type: "no-result",
            },
          ]}
        />
      ) : null}
      {isLabHeadDeputy() || isAdmin() ? (
        <SidebarList
          title="Заведующий лабораторией"
          titleIsOpen={isOpen.lab_head_deputy}
          toggleSidebar={() => toggleSidebar("lab_head_deputy")}
          color="olive"
          items={[
            {
              link: "/sout/locations/Compare",
              content: (
                <>
                  <FaArrowsAltV className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Сравнение</b>
                </>
              ),
              type: "default",
            },
            {
              link: "",
              content: "",
              type: "space",
            },
            {
              link: "/sout/locations/GlobalSearch",
              content: (
                <>
                  <FaSearch className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Общий поиск</b>
                </>
              ),
              type: "default",
            },
            {
              link: "/sout/locations/Actual",
              content: (
                <>
                  <FaBars className="sidebar__icon-search" />{" "}
                  <b className="sidebar__search-span">Все актуальные </b>
                </>
              ),
              type: "default",
            },
            {
              link: "/sout/locations/unassigned",
              content: "Неназначенные",
              type: "default",
            },
            {
              link: "/sout/locations/planned",
              content: "Планируемые",
              type: "default",
            },
            {
              link: "/sout/locations/inLeaving",
              content: "На выезде",
              type: "default",
            },
            {
              link: "/sout/locations/finish",
              content: "Завершённые",
              type: "default",
            },
            {
              link: "/sout/locations/archive",
              content: "Архив",
              type: "archive",
            },
            {
              link: "/sout/locations/basket",
              content: "Корзина",
              type: "no-result",
            },
          ]}
        />
      ) : null}
      {isLabExpert() || isAdmin() ? (
        <SidebarList
          title="Эксперт лаборатории"
          titleIsOpen={isOpen.lab_expert}
          toggleSidebar={() => toggleSidebar("lab_expert")}
          color="olive"
          items={[
            {
              type: "line",
            },
          ]}
        />
      ) : null}
      {isLabEmployee() || isAdmin() ? (
        <SidebarList
          title="Лаборатория"
          titleIsOpen={isOpen.lab_assist}
          toggleSidebar={() => toggleSidebar("lab_assist")}
          color="olive"
          items={[
            {
              type: "line",
            },
          ]}
        />
      ) : null}
      {isAccountantUser() || isAdmin() ? (
        <SidebarList
          title="Бухгалтерия"
          titleIsOpen={isOpen.accountant}
          toggleSidebar={() => toggleSidebar("accountant")}
          color="olive"
          items={[
            {
              type: "line",
            },
          ]}
        />
      ) : null}
      {isAdmin() ? (
        <SidebarList
          title="Админ"
          titleIsOpen={isOpen.admin}
          toggleSidebar={() => toggleSidebar("admin")}
          color="olive"
          items={MAIN_LIST}
        />
      ) : null}
    </>
  );
};

export default LocationsSidebar;
